import React from 'react';
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Box,
  List,
  ListItem,
  Chip,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Modal,
  Typography,
  styled,
  TablePagination,
  TextField,
} from '@mui/material';
import moment from 'moment';
import { axiosGetCall, axiosPostCall } from '../../services/apisCall';
import NetworkError from '../../components/Error/networkError';
import { CustomSkeleton } from '../../sections/skeleton/skeletonLoader';
import VerifiedIcon from '@mui/icons-material/Verified';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { CustomMenu } from '../../components/menu/customMenu';
import PreviewComponent from './preview';
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';
import { Icon } from '@iconify/react';
import { TokenContext } from '.././../context/TokenContext';
import { jwtDecode } from 'jwt-decode';
import { useNavigate } from 'react-router-dom';
import DeleteIcon from '@mui/icons-material/Delete';
import SendIcon from '@mui/icons-material/Send';
import FileUploadOutlinedIcon from '@mui/icons-material/FileUploadOutlined';
import FileUploadDialog from './FileUploadDialog';
import CommentDialog from './commentDialog';
import { useSnackbar } from 'src/components/snackbar';
import { CircularProgress } from '@mui/material';
import { renderErrorMessage, renderSuccessMessage } from '../../lib/toastMessage';
import UpdateIcon from '@mui/icons-material/Update';
import PaymentForm from './paymentForm';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import Tooltip from '@mui/material/Tooltip';
import HourglassBottomRoundedIcon from '@mui/icons-material/HourglassBottomRounded';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import DoneAllIcon from '@mui/icons-material/DoneAll';
import Badge from '@mui/material/Badge';
import FiberManualRecordTwoToneIcon from '@mui/icons-material/FiberManualRecordTwoTone';
import { checkButtonAccess } from '../../utils/common';
import InputAdornment from '@mui/material/InputAdornment';
import SearchIcon from '@mui/icons-material/Search';

const StyledBadge = styled(Badge)(({ theme }) => ({
  '& .MuiBadge-badge': {
    backgroundColor: '#44b700',
    color: '#44b700',
    boxShadow: `0 0 0 2px ${theme.palette.background.paper}`,
    '&::after': {
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      borderRadius: '50%',
      animation: 'ripple 1.2s infinite ease-in-out',
      border: '1px solid currentColor',
      content: '""',
    },
  },
  '@keyframes ripple': {
    '0%': {
      transform: 'scale(.8)',
      opacity: 1,
    },
    '100%': {
      transform: 'scale(2.4)',
      opacity: 0,
    },
  },
}));

export default function BillingList() {
  const navigate = useNavigate();
  const { token } = React.useContext(TokenContext);
  const { enqueueSnackbar } = useSnackbar();
  const [rows, setRows] = React.useState([]);

  const [searchTerm, setSearchTerm] = React.useState('');
  const [allRows, setAllRows] = React.useState([]);
  const [loading, setLoading] = React.useState(true);
  const [networkError, setNetworkError] = React.useState(false);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const [openModal, setOpenModal] = React.useState(false);
  const [selectedRows, setSelectedRows] = React.useState('');
  const [openPreview, setOpenPreview] = React.useState(null);
  const [userId, setUserId] = React.useState('');
  const [userRole, setUserRole] = React.useState('');
  const [user, setUser] = React.useState(false);
  const [openDialog, setOpenDialog] = React.useState(false);
  const [openDialogUpload, setOpenDialogUpload] = React.useState(false);
  const [loadingState, setLoadingState] = React.useState(false);
  const [openForm, setOpenForm] = React.useState(false);
  const [count, setCount] = React.useState(0);
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const [openCommentDialog, setOpenCommentDialog] = React.useState(false);
  const [commentText, setCommentText] = React.useState('');
  const [openCommentPreview, setOpenCommentPreview] = React.useState(false);
  const columns = [
    { id: 'fullName', label: 'Customer Name', minWidth: 120, align: 'center' },
    { id: 'toAddress', label: 'Customer Email', minWidth: 110, align: 'center' },
    { id: 'fromAddress', label: 'From Email', minWidth: 110, align: 'center' },
    { id: 'items', label: 'Services', minWidth: 110, align: 'center' },
    { id: 'date', label: 'Created By', minWidth: 110, align: 'center' },
    { id: 'date', label: 'Created At', minWidth: 100, align: 'center' },
    { id: 'totalDiscount', label: 'Total Discount', minWidth: 100, align: 'center' },
    { id: 'totalTax', label: 'Total Tax', minWidth: 110, align: 'center' },
    { id: 'netPayable', label: 'Net Payable(₹)', minWidth: 100, align: 'center' },
    { id: 'status', label: 'Status', minWidth: 100, align: 'center' },
    { id: 'payment', label: 'Payment Status', minWidth: 120, align: 'center' },
    { id: 'expireStatus', label: 'Expired At', minWidth: 100, align: 'center' },
    { id: 'status', label: 'Action', minWidth: 70, align: 'center' },
  ];
  React.useEffect(() => {
    if (token) {
      const { email = '', role = '' } = jwtDecode(token);
      setUserId(email);
      setUserRole(role);
    }
  }, [user]);
  const handleSearch = (term) => {
    setSearchTerm(term);
    setPage(0); // Reset to first page when searching
    getBillingList(); // Trigger API call with new search term
  };
  const getBillingList = async () => {
    try {
      const skip = rowsPerPage * page;
      const params = { skip, limit: rowsPerPage, search: searchTerm };
      const { result, total } = await axiosGetCall('getQuotationList', params);
      if (result) {
        setRows(result);
        setCount(total);
      }

      setLoading(false);
    } catch (error) {
      setNetworkError(true);
      setNetworkError(false);
      console.error('Error fetching billing list:', error);
      setRows([]);
      setLoading(false);
    }
  };
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  React.useEffect(() => {
    getBillingList();
  }, [page, rowsPerPage, openDialogUpload]);

  const formatCurrency = (value) => {
    return new Intl.NumberFormat('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(value);
  };

  const handleClick = (event, rows) => {
    setAnchorEl(event.currentTarget);
    setSelectedRows(rows);
    setUser(true);
  };

  const handleApproved = () => {
    setAnchorEl(null);
    setOpenCommentDialog(true);
    setOpenPreview('Approved');
  };
  const handleComment = () => {
    setAnchorEl(null);
    setOpenCommentDialog(true);
  };

  const handleEdit = () => {
    setAnchorEl(null);
    navigate('/create_quotation', { state: { data: selectedRows } });
  };
  const handleRejected = () => {
    setAnchorEl(null);
    setOpenPreview('Rejected');
  };
  const handleUpload = () => {
    setAnchorEl(null);
    setOpenDialogUpload(true);
  };
  const handleDeleted = () => {
    console.log('deleted clicked!!');
    setOpenDialog(true);
    setAnchorEl(null);
  };

  const handleClose = () => {
    setAnchorEl(null);
    setSelectedRows('');
    setOpenDialogUpload(false);
  };

  const handleOpenForm = () => {
    setOpenForm(true);
    setAnchorEl(null);
  };

  const handleCloseForm = () => setOpenForm(false);

  const handleSubmitForm = async (formData) => {
    try {
      formData.action = 'Update Payment';
      formData.flag = 6;

      formData.createdBy = selectedRows.createdBy;
      formData.user = userId;
      const { message } = await axiosPostCall('sendInvoice', { formData });
      if (message === 'Payment updated successfully!') {
        handleCloseForm();
        renderSuccessMessage(message);
        setLoadingState(false);
        setAnchorEl(null);
        getBillingList();
      } else {
        renderErrorMessage(message);
      }
    } catch (error) {
      console.log(error);
    }
  };
  const handleCommentSubmit = async (commentText) => {
    try {
      setCommentText(commentText);
      setOpenCommentDialog(false);
      handleApproved();
    } catch (error) {
      console.error('Error adding comment:', error);
      renderErrorMessage('Failed to add comment');
    } finally {
      setLoadingState(false);
    }
  };

  const Content = () => {
    const paymentStatus = selectedRows?.payment?.map((p) => p?.paymentStatus);

    const listItems = [
      {
        condition:
          userRole === 'superAdmin' && selectedRows.status !== 'Approved' && selectedRows.status !== 'Rejected',
        onClick: handleComment,
        icon: <VerifiedIcon sx={{ color: '#1976d2', height: '17px' }} />,
        label: 'Approve',
        color: 'primary',
      },
      // {
      //   condition:
      //     userRole === 'superAdmin' && selectedRows.status !== 'Approved' && selectedRows.status !== 'Rejected',
      //   onClick: handleComment,
      //   icon: <VerifiedIcon sx={{ color: '#1976d2', height: '17px' }} />,
      //   label: 'Add Comment',
      //   color: 'primary',
      // },
      {
        condition:
          userRole === 'superAdmin' && selectedRows.status !== 'Approved' && selectedRows.status !== 'Rejected',
        onClick: handleRejected,
        icon: <CancelOutlinedIcon sx={{ color: '#f44336', height: '17px' }} />,
        label: 'Reject',
        color: 'grey.700',
      },
      {
        condition:
          checkButtonAccess('billingPageList', 'r') &&
          checkButtonAccess('sendTaxInvoice', 'w') &&
          selectedRows.status === 'Approved' &&
          selectedRows.sendQuotation !== 'sent',
        onClick: sendQuotation,
        icon: (
          <>
            {loadingState ? (
              <CircularProgress size={17} sx={{ color: '#1976d2' }} />
            ) : (
              <SendIcon sx={{ color: '#1976d2', height: '17px' }} />
            )}
          </>
        ),
        label: loadingState ? 'Sending...' : 'Send Quotation',
        color: 'primary',
      },
      {
        condition:
          checkButtonAccess('billingPageList', 'r') &&
          checkButtonAccess('sendTaxInvoice', 'w') &&
          selectedRows.status === 'Approved' &&
          selectedRows.sendQuotation === 'sent' &&
          selectedRows.sendPerformaInvoice !== 'sent',
        onClick: sendInvoice,
        icon: (
          <>
            {loadingState ? (
              <CircularProgress size={17} sx={{ color: '#1976d2' }} />
            ) : (
              <SendIcon sx={{ color: '#1976d2', height: '17px' }} />
            )}
          </>
        ),
        label: loadingState ? 'Sending...' : 'Send Proforma Invoice',
        color: 'primary',
      },
      {
        condition:
          checkButtonAccess('quotationAnalysisList', 'w') &&
          selectedRows.status === 'Approved' &&
          selectedRows.sendPerformaInvoice === 'sent' &&
          !paymentStatus?.includes('Completed') &&
          !paymentStatus?.includes('Partial'),
        onClick: handleOpenForm,
        icon: <UpdateIcon sx={{ color: '#50AB64', height: '19px' }} />,
        label: 'Upload Payment Details',
        color: 'primary',
      },
      {
        condition:
          checkButtonAccess('quotationAnalysisList', 'w') &&
          selectedRows.status === 'Approved' &&
          selectedRows.sendPerformaInvoice === 'sent' &&
          paymentStatus?.includes('Completed') &&
          selectedRows.taxInvoice !== 'uploadedTaxInvoice',
        onClick: handleUpload,
        icon: <FileUploadOutlinedIcon sx={{ color: '#1976d2', height: '19px' }} />,
        label: 'Upload Tax Invoice',
        color: 'primary',
      },
      {
        condition:
          (checkButtonAccess('billingPageList', 'r') || checkButtonAccess('quotationAnalysisList', 'w')) &&
          selectedRows.status === 'Approved' &&
          selectedRows.sendPerformaInvoice === 'sent' &&
          paymentStatus?.includes('Completed') &&
          selectedRows.taxInvoice === 'uploadedTaxInvoice',
        icon: <DoneAllIcon sx={{ color: '#1976d2', height: '19px' }} />,
        label: 'All actions completed',
        color: 'primary',
      },
    ];

    const hideEditDelete = selectedRows.sendPerformaInvoice === 'sent';
    const hasActions = listItems.some(({ condition }) => condition);
    const sharedStyles = {
      display: 'flex',
      gap: '7px',
      fontWeight: 400,
      '&:hover': {
        color: 'grey.800',
        backgroundColor: 'grey.300',
        cursor: 'pointer',
      },
    };
    return (
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: '16px',
        }}
      >
        <List>
          {selectedRows?.commentText && (
            <ListItem
              sx={{ ...sharedStyles }}
              onClick={() => {
                setOpenCommentPreview(true);
                setAnchorEl(null);
              }}
            >
              <Icon icon="mdi:comment-eye" style={{ marginRight: '8px' }} />
              View Comment
            </ListItem>
          )}
          {hasActions ? (
            listItems.map(({ condition, onClick, icon, label, color }, index) =>
              condition ? (
                <ListItem
                  key={index}
                  sx={{
                    ...sharedStyles,
                    color,
                  }}
                  onClick={onClick}
                >
                  {icon}
                  {label}
                </ListItem>
              ) : null
            )
          ) : (
            <ListItem sx={{ textAlign: 'center', color: '#f44336', fontWeight: 500 }}>No actions available</ListItem>
          )}

          {!hideEditDelete && (
            <>
              <ListItem
                sx={{
                  ...sharedStyles,
                  color: 'grey.700',
                }}
                onClick={handleEdit}
              >
                <Icon icon="lucide:edit" style={{ color: '#1976d2', height: '17px', margin: '5px' }} />
                Edit
              </ListItem>
              <ListItem
                sx={{
                  ...sharedStyles,
                  color: 'grey.700',
                }}
                onClick={handleDeleted}
              >
                <DeleteIcon sx={{ color: '#f44336', height: '17px' }} />
                Delete
              </ListItem>
            </>
          )}
        </List>
      </Box>
    );
  };

  const ActionModals = () => (
    <>
      <CustomMenu anchorEl={anchorEl} handleClose={handleClose} Content={Content} />
    </>
  );
  const style = {
    color: 'grey.700',
    borderBottom: '0.5px dashed',
    borderColor: 'grey.300',
    padding: '8px',
    height: '35px',
  };

  const handleDeleteConfirm = async () => {
    try {
      setLoadingState(true);
      selectedRows.status = 'Deleted';
      selectedRows.flag = 5;
      selectedRows.action = 'Deleted';
      formData.user = userId;
      const result = await axiosPostCall('sendInvoice', { formData: selectedRows });
      if (result.message === 'Invoice Deleted!') {
        setOpenDialog(false);
        getBillingList();
        renderErrorMessage(result.message);
        setLoadingState(false);
        setAnchorEl(null);
      } else {
        renderErrorMessage('Something went wrong!');
        enqueueSnackbar('Something went wrong!', {
          anchorOrigin: { vertical: 'top', horizontal: 'right' },
          variant: 'error',
        });
      }
    } catch (error) {
      console.error(error);
    }
  };

  const handleDeleteCancel = () => {
    setOpenDialog(false);
  };

  const sendQuotation = async () => {
    try {
      setLoadingState(true);
      selectedRows.flag = 7;
      selectedRows.action = 'Send quotation';
      selectedRows.user = userId;
      const { message } = await axiosPostCall('sendInvoice', { formData: selectedRows });
      if (message === 'Quotation sent successfully') {
        getBillingList();
        renderSuccessMessage(message);
        setLoadingState(false);
        setAnchorEl(null);
      } else {
        renderErrorMessage('Something went wrong!');
      }
    } catch (error) {
      console.error(error);
    }
  };

  const sendInvoice = async () => {
    try {
      setLoadingState(true);
      selectedRows.status = 'Approved';
      selectedRows.flag = 3;
      selectedRows.action = 'Send PI';
      selectedRows.user = userId;
      const { message } = await axiosPostCall('sendInvoice', { formData: selectedRows });
      if (message === 'Proforma Invoice sent successfully') {
        getBillingList();
        renderSuccessMessage(message);
        setLoadingState(false);
        setAnchorEl(null);
      } else {
        renderErrorMessage(message);
        setLoadingState(false);
        setAnchorEl(null);
      }
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <Paper sx={{ width: '100%', overflow: 'hidden' }}>
      <Box sx={{ p: 2, display: 'flex', gap: 1 }}>
        <TextField
          label="Search Quotation ID or Email"
          variant="outlined"
          size="small"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === 'Enter') {
              handleSearch(searchTerm);
            }
          }}
          sx={{ width: 250 }}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <SearchIcon color="disabled" />
              </InputAdornment>
            ),
          }}
        />
        <Button
          variant="contained"
          color="primary"
          onClick={() => handleSearch(searchTerm)} // Explicit search on click
          sx={{ height: '40px' }} // Match textfield height
        >
          Search
        </Button>
      </Box>
      <TableContainer sx={{ maxHeight: 'calc(100vh - 219px)' }}>
        <Table stickyHeader aria-label="sticky table" size="small">
          <TableHead sx={{ position: 'sticky' }}>
            <TableRow>
              {columns.map(({ id, label, align, minWidth }) => (
                <TableCell key={id} align={align} sx={{ minWidth, padding: '8px', height: '35px', marginLeft: '18px' }}>
                  {label}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {loading ? (
              <TableRow>
                {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13].map((item) => (
                  <TableCell
                    key={item}
                    align={'center'}
                    sx={{
                      color: 'grey.400',
                      borderBottom: '1px solid',
                      borderColor: 'grey.800',
                    }}
                  >
                    <CustomSkeleton variant={'text'} component={'h6'} width={'100%'} />
                  </TableCell>
                ))}
              </TableRow>
            ) : rows.length > 0 ? (
              rows.map((row, i) => {
                const {
                  toAddress = {},
                  fromAddress = {},
                  items = [],
                  createdBy = '--',
                  createdAt,
                  totalDiscount = '--',
                  totalTax = '--',
                  netPayable,
                  payment = '--',
                  status,
                  expireStatus,
                  expireDate,
                } = row;

                const showBadge = expireStatus === 'active';
                const paymentStatuses = payment?.map((p) => p?.paymentStatus);
                const chipStyles = {
                  Rejected: {
                    color: '#E2533F',
                    backgroundColor: 'rgba(236, 64, 64, 0.20)',
                  },
                  Approved: {
                    color: '#50AB64',
                    backgroundColor: 'rgba(80, 171, 100, 0.20)',
                  },
                  Default: {
                    color: '#D19244',
                    backgroundColor: 'rgba(209, 146, 68, 0.20)',
                  },
                };

                const { color, backgroundColor } = chipStyles[status] || chipStyles.Default;
                const expTitle = `Expires on ${expireDate ? moment(expireDate).format('DD MMM, YYYY') : '--'}`;

                return (
                  <TableRow hover key={`row-${i}`}>
                    <TableCell align="center" sx={style} key={`toAddress-${i}`}>
                      {toAddress.fullName || '--'}
                    </TableCell>
                    <TableCell align="center" sx={style} key={`toEmail-${i}`}>
                      {toAddress.email || '--'}
                    </TableCell>
                    <TableCell align="center" sx={style} key={`fromEmail-${i}`}>
                      {fromAddress.email || '--'}
                    </TableCell>
                    <TableCell align="center" sx={style} key={`items-${i}`}>
                      {items.map((item) => item.product).join(', ') || '--'}
                    </TableCell>
                    <TableCell align="center" sx={style} key={`createdBy-${i}`}>
                      {createdBy}
                    </TableCell>
                    <TableCell align="center" sx={style} key={`createdAt-${i}`}>
                      {createdAt ? moment(createdAt).format('DD MMM, YYYY') : '--'}
                    </TableCell>
                    <TableCell align="center" sx={style} key={`discount-${i}`}>
                      {formatCurrency(totalDiscount)}
                    </TableCell>
                    <TableCell align="center" sx={style} key={`tax-${i}`}>
                      {formatCurrency(totalTax)}
                    </TableCell>
                    <TableCell align="center" sx={style} key={`netPayable-${i}`}>
                      {formatCurrency(netPayable) || '--'}
                    </TableCell>
                    <TableCell align="center" sx={style} key={`status-${i}`}>
                      <Chip
                        label={status}
                        sx={{
                          color,
                          backgroundColor,
                          p: '2px 0px',
                          height: 'auto',
                          borderRadius: 1,
                          fontWeight: 500,
                          '&:hover': { backgroundColor },
                        }}
                      />
                    </TableCell>
                    <TableCell align="center" sx={style} key={`paymentStatus-${i}`}>
                      {paymentStatuses?.includes('Completed') ? (
                        <Tooltip title="Completed">
                          <CheckCircleIcon sx={{ color: '#50AB64', height: '18px' }} />
                        </Tooltip>
                      ) : paymentStatuses?.includes('Failed') ? (
                        <Tooltip title="Failed">
                          <CloseRoundedIcon sx={{ color: '#E2533F', height: '18px' }} />
                        </Tooltip>
                      ) : paymentStatuses?.includes('Partial') ? (
                        <Tooltip title="Partial">
                          <HourglassBottomRoundedIcon sx={{ color: '#D19244', height: '18px' }} />
                        </Tooltip>
                      ) : paymentStatuses?.includes('Pending') ? (
                        <Tooltip title="Pending">
                          <HourglassBottomRoundedIcon sx={{ color: 'yellow' }} />
                        </Tooltip>
                      ) : (
                        '--'
                      )}
                    </TableCell>
                    {console.log(
                      'exp===',
                      expireDate,
                      typeof expireDate,
                      moment(Number(expireDate)).format('DD MMM, YYYY')
                    )}
                    <TableCell align="center" sx={style} key={`expireStatus-${i}`}>
                      {expireStatus === 'active' ? (
                        <Chip
                          label={
                            // Check if expireDate is a string that can be converted to a number
                            !isNaN(expireDate)
                              ? moment(Number(expireDate)).format('DD MMM, YYYY')
                              : moment(expireDate).isValid()
                                ? moment(expireDate).format('DD MMM, YYYY')
                                : '--'
                          }
                          sx={{
                            color: '#50AB64',
                            backgroundColor: 'rgba(80, 171, 100, 0.20)',
                            p: '2px 0px',
                            height: 'auto',
                            borderRadius: 1,
                            fontWeight: 500,
                            '&:hover': { backgroundColor: 'rgba(80, 171, 100, 0.20)' },
                          }}
                        />
                      ) : (
                        <Chip
                          label={
                            !isNaN(expireDate)
                              ? moment(Number(expireDate)).format('DD MMM, YYYY')
                              : moment(expireDate).isValid()
                                ? moment(expireDate).format('DD MMM, YYYY')
                                : '--'
                          }
                          sx={{
                            color: '#E2533F',
                            backgroundColor: 'rgba(236, 64, 64, 0.20)',
                            p: '2px 0px',
                            height: 'auto',
                            borderRadius: 1,
                            fontWeight: 500,
                            '&:hover': { backgroundColor: 'rgba(236, 64, 64, 0.20)' },
                          }}
                        />
                      )}
                    </TableCell>
                    <TableCell align="center" sx={style} key={`actions-${i}`}>
                      <MoreVertIcon
                        sx={{
                          color: 'grey.700',
                          height: '18px',
                          width: '18px',
                          cursor: 'pointer',
                        }}
                        onClick={(e) => handleClick(e, row)}
                      />
                    </TableCell>
                  </TableRow>
                );
              })
            ) : (
              <TableRow>
                <TableCell align="center" colSpan={columns.length}>
                  No data available
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[10, 25, 100]}
        component="div"
        count={count}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
      {!(rows || loading) && (
        <Box
          sx={{
            width: '100%',
            height: '48vh',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <NetworkError message={!networkError ? commonMessage?.noDataFound : commonMessage?.networkError} />
        </Box>
      )}
      {open && <ActionModals />}
      {openPreview && (
        <PreviewComponent
          open={openPreview}
          setOpen={setOpenPreview}
          order={selectedRows}
          openModal={openModal}
          setOpenModal={setOpenModal}
          userId={userId}
          comment={commentText}
        />
      )}
      <Dialog open={openDialog} onClose={handleDeleteCancel}>
        <DialogTitle>Confirm Deletion</DialogTitle>
        <DialogContent>Are you sure you want to delete this quotation ?</DialogContent>
        <DialogActions>
          <Button onClick={handleDeleteCancel} color="primary">
            Cancel
          </Button>
          <Button onClick={handleDeleteConfirm} color="error">
            {loadingState ? (
              <>
                <CircularProgress size={17} sx={{ color: 'error', marginRight: '8px' }} /> Deleting...{' '}
              </>
            ) : (
              'Delete'
            )}
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog open={openCommentPreview} onClose={() => setOpenCommentPreview(false)}>
        <DialogTitle>Comment</DialogTitle>
        <DialogContent>
          <Typography sx={{ whiteSpace: 'pre-line' }}>{selectedRows?.commentText || 'No comment'}</Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenCommentPreview(false)}>Close</Button>
        </DialogActions>
      </Dialog>

      <Modal open={openForm} onClose={handleCloseForm}>
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: 600,
            bgcolor: 'background.paper',
            boxShadow: 24,
            p: 4,
            borderRadius: 2,
          }}
        >
          <Typography variant="h6" component="h2" mb={2}>
            Payment Details
          </Typography>
          <PaymentForm onSubmit={handleSubmitForm} />
        </Box>
      </Modal>
      <FileUploadDialog
        openDialog={openDialogUpload}
        handleClose={handleClose}
        data={selectedRows}
        setOpenDialogUpload={setOpenDialogUpload}
      />
      <CommentDialog
        open={openCommentDialog}
        onClose={() => setOpenCommentDialog(false)}
        onSubmit={handleCommentSubmit}
      />
    </Paper>
  );
}
